// extracted by mini-css-extract-plugin
export default {"advertDetailService__label":"c-n_fU","advertDetailService__price":"c-n_fV"};